module.exports = __webpack_public_path__ + "img/ez-slot-three-candy.480944a9.png";